import { ChapterState } from '../../../../../../../../../../../lib/models/TemplateTypes';
import styles from './styles.module.scss';
import { CircleIconNew } from '../../../../../../../../../../../ui/icons/CircleIconNew';
import { OneIcon } from '../../../../../../../../../../../ui/icons/OneIcon';

export function Card({ state, chapterIcon, shouldShowImage, isBorderAnimation, isImageAnimation }) {
  const isNotOpened = state === ChapterState.NOT_OPENED;

  return (
    <div
      tabIndex={isNotOpened ? undefined : 0}
      className={`${styles.card} ${isBorderAnimation ? styles.cardBorderActive : ''} ${isBorderAnimation ? styles.cardBorderAnimation : ''}`}
      role='button'
      style={{ pointerEvents: isNotOpened ? 'none' : 'auto' }}
    >
      <div className={styles.frame}>
        {chapterIcon && shouldShowImage ? (
          <img
            className={`${styles.frameImg} ${isImageAnimation ? styles.frameImgAnimation : ''}`}
            src={chapterIcon}
            alt='Chapter icon'
            draggable={false}
          />
        ) : (
          <div className={styles.circleWrapper}>
            <span className={styles.iconNumber}>
              <OneIcon width={38} height={54} />
            </span>
            <CircleIconNew width={125} height={125} />
          </div>
        )}
      </div>
    </div>
  );
}
